module.exports = __webpack_public_path__ + "media/video1.3ff9a591.mp4";